import React from "react";

import { ReactComponent as ZapierLogo } from "~/legacy-assets/images/logos/zapier.svg";

import Card from "../../../account/Integrations/Card";

interface ZapierProps {
	className?: string;
	connected: boolean;
}

export function ZapierCard(props: ZapierProps) {
	return (
		<Card
			name="Zapier"
			description="Use Zapier to integrate hundreds of apps with Fellow"
			connected={props.connected}
			logo={<ZapierLogo style={{ width: "auto", height: "24px" }} />}
			className={props.className}
		/>
	);
}
